import React, { useState, useRef } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import CamIconButton from "../CamIcon/CamIcon";
import DroneIconButton from "../DroneIcon/DroneIcon";
import ModalUploadVideoNewMission from "../ModalUploadVideoNewMission/ModalUploadVideoNewMission";
import ModalUploadImageNewMission from "../ModalUploadImageNewMission/ModalUploadImageNewMission";
import { ReactComponent as EnviarDados } from "../../assets/icons/ENVIAR_DADOS.svg";
import "./ModalUpload.css";

const ModalUpload = ({ toggle, updateMissions }) => {
  const [uploadType, setUploadType] = useState("");
  const videoUploadRef = useRef(null);
  const imageUploadRef = useRef(null);

  const handleBackClick = () => {
    if (uploadType === "street" && videoUploadRef.current) {
      videoUploadRef.current.cancelUploads();
    } else if (uploadType === "light") {
      if (videoUploadRef.current) videoUploadRef.current.cancelUploads();
      if (imageUploadRef.current) imageUploadRef.current.cancelUploads();
    }
    setUploadType("");
  };

  const toggleAndCancelUploads = () => {
    handleBackClick();
    toggle();
  };

  return (
    <Modal
      isOpen={true}
      toggle={toggle}
      style={
        uploadType === "light" ? { width: "fit-content", maxWidth: "100%" } : {}
      }
    >
      <ModalHeader
        toggle={toggleAndCancelUploads}
        style={uploadType === "" ? { padding: "0 1rem" } : undefined}
      >
        <div className="row m-0">
          <div className="col-2 m-auto">
            {uploadType ? (
              <FaArrowLeft
                onClick={handleBackClick}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <EnviarDados style={{ width: "25px" }} />
            )}
          </div>
          <div
            className="col m-auto d-flex"
            style={{ alignItems: "center", gap: ".3rem", fontWeight: "bold" }}
          >
            Enviar dados...
          </div>
        </div>
      </ModalHeader>

      <ModalBody>
        {uploadType === "street" && (
          <ModalUploadVideoNewMission
            ref={videoUploadRef}
            toggle={() => setUploadType("")}
            updateMissions={updateMissions}
          />
        )}

        {uploadType === "light" && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "2rem" }}
          >
            <div className="d-flex flex-column align-items-center w-100">
              <ModalUploadVideoNewMission
                ref={videoUploadRef}
                toggle={() => setUploadType("")}
                updateMissions={updateMissions}
                lightUpload={true}
              />
            </div>
            <div
              style={{
                width: "1px",
                height: "-webkit-fill-available",
                backgroundColor: "#ccc",
              }}
            ></div>
            <div className="d-flex flex-column align-items-center w-100">
              <ModalUploadImageNewMission
                ref={imageUploadRef}
                toggle={() => setUploadType("")}
                updateMissions={updateMissions}
              />
            </div>
          </div>
        )}

        {!uploadType && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "2rem" }}
          >
            <div className="d-flex flex-column align-items-center">
              <Button
                color="#fff"
                className="send-data-button"
                onClick={() => setUploadType("street")}
                style={{ paddingTop: "1rem" }}
              >
                <CamIconButton width="70px" height="70px" />
                <span>Rua</span>
              </Button>
            </div>
            <div className="d-flex flex-column align-items-center">
              <Button
                color="#fff"
                className="send-data-button"
                onClick={() => setUploadType("light")}
              >
                <DroneIconButton width="100px" height="100px" />
                <span>Drone</span>
              </Button>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalUpload;
